import { useFormContext } from "react-hook-form";
import {
  formatarMonetárioParaNúmero,
  formatarValorMonetario,
} from "../../../../../../../../helpers/masks";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useMemo } from "react";

export default function AlertMarcarJuros() {
  const { setValue, watch } = useFormContext();

  const totalAtt = watch("total_atualizado");
  const valorInputs = watch("finalizacao.recebimentos");
  const valueRadio = watch("finalizacao.aplicarDiferencaComoJuros");

  const { perguntarSobreJuros, diffValor } = useMemo(() => {
    let totalValor = 0;
    const params = {
      perguntarSobreJuros: false,
      diffValor: 0,
    };

    if (valorInputs.length > 0) {
      totalValor = valorInputs.reduce(
        (acumulador: number, item: any) =>
          acumulador + formatarMonetárioParaNúmero(item.valor),
        0
      );
      totalValor = Math.round(totalValor * 100) / 100;
      params.perguntarSobreJuros = totalValor > totalAtt;
      params.diffValor = totalValor - totalAtt;
    }

    return params;
  }, [valorInputs, totalAtt]);

  const handleChangeRadio = (value: boolean) => {
    setValue("finalizacao.aplicarDiferencaComoJuros", value);
  };

  useMemo(() => {
    if (!perguntarSobreJuros) {
      setValue("finalizacao.aplicarDiferencaComoJuros", false);
    }
  }, [perguntarSobreJuros, setValue]);

  if (perguntarSobreJuros)
    return (
      <Box
        p={2}
        borderRadius={1}
        bgcolor="#e3f2fd"
        sx={{ color: "#000" }}
        mt={2}
      >
        <Typography variant="subtitle2">
          A soma dos valores informados é maior que o total atualizado. O valor
          excedente de <b>{formatarValorMonetario(diffValor)}</b> será aplicado
          como juros extra. Deseja continuar? 
        </Typography>

        <FormControl>
          <RadioGroup
            row
            aria-labelledby="aplicar-como-juros"
            value={valueRadio}
            onChange={(e) => handleChangeRadio(e.target.value === "true")}
          >
            <FormControlLabel
              value={true}
              control={<Radio color="info" size="small" />}
              label="Sim"
            />
            <FormControlLabel
              value={false}
              control={<Radio color="info" size="small" />}
              label="Não"
            />
          </RadioGroup>
        </FormControl>
      </Box>
    );

  return null;
}
